const _temp0 = require("./scenery/city.scenery.ts");

const _temp1 = require("./scenery/bridge/bridge.scenery.ts");



const _temp2 = require("./sinterklaas/garden.scenery.ts");

const _temp3 = require("./sinterklaas/town.scenery.ts");


const _temp4 = require("./test/test.scenery.js");


module.exports = {
  "scenery":   {
    "city":     {
      "ts": _temp0
    },
    "bridge":     {
      "bridge":       {
        "ts": _temp1
      }
    }
  },
  "sinterklaas":   {
    "garden":     {
      "ts": _temp2
    },
    "town":     {
      "ts": _temp3
    }
  },
  "test":   {
    "test":     {
      "js": _temp4
    }
  }
}